/* eslint-disable */
import React, { Component } from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import Collapsible from 'react-collapsible';

import Layout from '../layout';

import styles from '../styles/pages/frequent-questions.scss';
import stylesIcon from '../shared/styles/header.scss';

import SignupPromotion from '../shared/signup-promotion';

const faqs = [
    {
        questionDefault: "1. En qué provincias entregan?",
        answerDefaults: [
            "R/ Entregamos en La Habana, Artemisa, Mayabeque, Pinar del Río, Matanzas, Ciego de Ávila, Las Tunas, Holguín, Camagüey, Sancti Spíritus, Granma y Santiago de Cuba.",
            "Estamos trabajando para extender nuestros servicios al resto de las provincias."
        ]
    }, {
        questionDefault: "2. Cuántos días demora la entrega de las órdenes?",
        answerDefaults: [
            "R/ Las entregas en la tienda de CubaLicores demoran aproximadamente 8 días hábiles. No se incluyen fines de semana. Las compras realizadas en la tienda de Pre-Venta pueden tardar de 30-60 días dependiendo de los productos comprados.",
            "Por favor tenga en cuenta que nuestras fechas son estimadas y no exactas.",
            "Para conocer sobre los tiempos de envío en otras tiendas de la plataforma por favor visite nuestras Políticas de Envíos y Cargos (https://www.cubalicores.com/shipping-policy)."
        ]
    }, {
        questionDefault: "3. Cómo puedo comprar?",
        answerDefaults: [
            "R/ Toda la compra se hace online en nuestro sitio www.cubalicores.com. Seleccione los productos, los agrega al carrito y procede a pagar. No recibimos órdenes vía telefónica.",
            "Puede registrarse en nuestra pagina web y acceder a su perfil o completar su compra sin registrarse."
        ]
    }, {
        questionDefault: "4. Cómo saber si tienen un producto? Cuándo abastecen la tienda?",
        answerDefaults: [
            "R/ Todos los productos disponibles los puede encontrar en nuestro sitio web www.cubalicores.com. No tenemos horarios o fechas específicas para surtir, sugerimos mantenerse al tanto de nuestras redes sociales para actualizaciones sobre nuevos productos y ofertas."
        ]
    }, {
        questionDefault: "5. Cuánto es el costo de envío?",
        answerDefaults: [
            "R/ El Envío Regular + Cargo por Manejo tiene un costo de $18 USD para todas las provincias en las tiendas de CubaLicores.",
            "Para conocer sobre los costos de envío en otras tiendas de la plataforma por favor visite nuestras Políticas de Envíos y Cargos ( https://www.cubalicores.com/shipping-policy )."
        ]
    }, {
        questionDefault: "6. Existe un monto mínimo/máximo de compra?",
        answerDefaults: [
            "R/ No tenemos montos mínimos o máximos de compra. Asimismo, puede realizar la cantidad de órdenes que considere en un mismo día o período de tiempo. Para algunos productos, sin embargo, podemos establecer límites en las cantidades a ordenar."
        ]
    }, {
        questionDefault: "7. Puedo pagar con la tarjeta del Banco Metropolitano u otro banco cubano?",
        answerDefaults: [
            "R/ Por el momento solo aceptamos pagos con tarjetas Visa, Mastercard, Discover o cualquier otra de banco extranjero."
        ]
    }, {
        questionDefault: "8. Puedo pagar en efectivo cuando reciba los productos?",
        answerDefaults: [
            "R/ No aceptamos pagos en efectivo. Toda la transacción se realiza online en el momento de la compra. "
        ]
    }, {
        questionDefault: "9. Mi familiar en Cuba, ¿tiene que pagar algo?",
        answerDefaults: [
            "R/ En Cuba no se paga nada."
        ]
    }, {
        questionDefault: "10. Cómo sabe mi familiar en Cuba el día que le llevarán la orden?",
        answerDefaults: [
            "R/ Hacemos una llamada a su familiar una vez usted realice el pedido para verificar sus datos y dirección de entrega (Ver pregunta 12 para más información sobre esta llamada) A partir de ese momento debe contar con que la orden llegará en los próximos 8 días hábiles o 30 -60 si es una orden de Pre-Venta.",
            "24 horas antes de la entrega usted recibe un correo electrónico que anuncia que su pedido está listo para ser Enviado y debe notificar a su familiar. El cliente que realiza la orden es responsable de proveer los datos de contacto en Cuba correctamente, así como de notificar al destinatario cuando reciba el email de Envío de la orden, de lo contrario puede significar atrasos en la entrega."
        ]
    }, {
        questionDefault: "11. Hice una orden y mi familiar no ha recibido ninguna llamada.",
        answerDefaults: [
            "R/ Si ha realizado previamente órdenes para el mismo destinatario, podemos confirmar la dirección de entrega directamente desde el sistema y omitir la primera llamada. Su familiar solo debe esperar el tiempo estimado de entrega."
        ]
    }, {
        questionDefault: "12. Qué venden además de comida?",
        answerDefaults: [
            "R/ Nuestra plataforma está diseñada para vender mucho más que productos de mercado. Hemos incrementado nuestras ofertas sumando emprendimientos cubanos que venden comidas elaboradas de restaurantes, dulces, bisutería, artículos decorativos, flores y mucho más. Manténgase al tanto a través de nuestras redes sociales de los nuevos negocios y productos que vamos incorporando."
        ]
    }, {
        questionDefault: "13. Cómo saber si mi orden se completó satisfactoriamente?",
        answerDefaults: [
            "R/ Hay dos elementos que le indicarán que su orden se completó sin problemas: Primero veri- fique que recibió el correo de confirmación de su pedido (mire también en la carpeta de spam). Luego verifique que se hizo el cargo a su tarjeta a nombre de CubaLicores. Si alguno de estos indicadores falla significa que no recibimos su pedido. Usted es responsable de escribir correctamente el correo electrónico donde recibirá la confirmación de la orden."
        ]
    }, {
        questionDefault: "14. Cómo puedo darle seguimiento a mi orden?",
        answerDefaults: [
            "R/ Si necesita saber el estado de su orden comuníquese con nosotros a través del botón de chat en nuestro sitio web. Tenga en cuenta que los pedidos de CubaLicores tardan entre 10 y 12 días hábiles para ser entregados. Las órdenes de Pre-Venta pueden ser entregadas entre 30 - 60 días. No nos contacte si aún su compra se encuentra dentro del plazo estimado de entrega."
        ]
    }, {
        questionDefault: "15. Si mi tarjeta no es en USD cómo realizan el cambio de moneda?",
        answerDefaults: [
            "R/ Nuestros precios son exclusivamente en USD. Es el banco de su tarjeta quien realiza la conversión de moneda según la tasa que tenga establecida."
        ]
    }, {
        questionDefault: "16. Tienen algún lugar donde recoger los pedidos?",
        answerDefaults: [
            "R/ No. Todas las entregas son exclusivamente a domicilio."
        ]
    }, {
        questionDefault: "17. Estoy haciendo una compra y mi tarjeta fue declinada",
        answerDefaults: [
            "R/ Si su tarjeta fue declinada, sin especificar el motivo, debe consultar con su banco. Si este le confirma que no tiene problemas, y aun así no puede comprar en nuestro sitio, sugerimos utilizar otra tarjeta."
        ]
    }, {
        questionDefault: "18. Me han Cancelado una orden, ¿cuándo tendré mi dinero de vuelta? ",
        answerDefaults: [
            "R/ Si cancelamos su orden, es muy probable que se deba a un error de inventario. Antes de cancelarla, le enviamos un correo electrónico anunciándole, y luego un segundo correo confirmando el procesamiento de su reembolso.",
            "Una vez procesado el reembolso (dígase a partir de que recibe el segundo correo electrónico), puede tardar de 3-5 días para que se refleje en su cuenta, dependiendo del banco de su tarjeta.",
            "El total de su dinero es reembolsado a la misma tarjeta con la que realizó su compra."
        ]
    }, {
        questionDefault: "19. Hice una orden y no recibí el correo electrónico de Confirmación",
        answerDefaults: [
            "R/ Puede suceder por varios motivos, el más común está relacionado con errores tipográficos al escribir su correo electrónico antes de pagar.",
            "Si realizó una orden y no recibió el email de confirmación, por favor comuníquese con nosotros a través de nuestro chat en el sitio web o por el email info@cubalicores.com. Envíenos nombre, apellidos, correo electrónico, monto y los 4 últimos dígitos de la tarjeta que utilizó.",
            "Por favor asegúrese que el cargo de su orden esté reflejado en su tarjeta. De lo contrario, sugerimos repetir la compra."
        ]
    }, {
        questionDefault: "20. Escribo al Centro de Ayuda y envío correos electrónicos y no recibo respuesta. Qué puede suceder?",
        answerDefaults: [
            "R/ Usualmente experimentamos altos volúmenes de comunicaciones diarias. Es por esto que en ocasiones la respuesta por parte de nuestros agentes puede demorar entre 24 y 48 horas. Sin embargo, todas las solicitudes recibidas son atendidas.",
            "Para contribuir a que se acorten los tiempos de respuesta, sugerimos:",
            "1. Asegurarse de que su orden superó el tiempo estimado de entrega.",
            "2. Incluir en su solicitud el # de Orden y/o datos del cliente que realizó la orden, cuando corresponda.",
            "3. Revisar la información que tenemos disponible en nuestras Políticas de Envío y Cargos (https://www.cubalicores.com/shipping-policy) y nuestras Políticas de Reclamaciones y Devoluciones (https://www.cubalicores.com/return-policy)"
        ]
    }
]

class FrequentQuestions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showIndex: 0,
        };

        document.title = this.props.intl.formatMessage({ id: 'frequent-questions-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'frequent-questions-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
        }
    }

    setSelectedIndex(index) {
        this.setState({ showIndex: index });
    }

    render() {
        const CollapseTitle = (title, index) => (
            <div className={styles.accordion}>
                <div className="text-justify">
                    {title}
                    <i
                        className={`pe-1x pe-va font-weight-bold ${stylesIcon.angleDown} ${styles.chevron} ${index === this.state.showIndex ? 'pe-7s-angle-up' : 'pe-7s-angle-down'}`}
                    />
                </div>
            </div>
        );

        const Paragraph = (props) => (
            <li style={{ paddingLeft: 15, paddingBottom: 5 }} className="text-justify">
                {props.children}
            </li>
        );

        return (
            <Layout notShowMarginBottom>
                <div className="container">
                    <div className="row">
                        <h4 className={styles.mainText}>
                            <FormattedMessage id="frequent-questions-title" defaultMessage="FREQUENT QUESTIONS" />
                        </h4>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className={styles.privacyBackround}>
                                {
                                    faqs.map((item, index) =>
                                        <Collapsible
                                            trigger={CollapseTitle(
                                                <FormattedMessage
                                                    id={`frequent-questions-subtitle${index + 1}`}
                                                    defaultMessage={item.questionDefault}
                                                />,
                                                index + 1
                                            )}
                                            onClose={() => this.setSelectedIndex(0)}
                                            onOpen={() => this.setSelectedIndex(index + 1)}
                                            transitionTime={200}
                                            key={index + 1}
                                        >
                                            <ul>
                                                {item.answerDefaults.map((answerDefault, paragraphIndex) =>
                                                    <Paragraph key={`${index + 1}-${paragraphIndex + 1}`}>
                                                        <FormattedHTMLMessage
                                                            id={`frequent-questions-response${index + 1}-${paragraphIndex + 1}`}
                                                            defaultMessage={answerDefault}
                                                        />
                                                    </Paragraph>
                                                )}
                                            </ul>
                                        </Collapsible>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(FrequentQuestions);



/** WEBPACK FOOTER **
 ** ./src/components/pages/frequent-questions.jsx
 **/